import { Button } from "react-bootstrap";

export const initCapitalFilterInput = {
  searchName: "",
  outlets: [],
  transactionStartDate: null,
  transactionEndDate: null,
  page: 1,
  pageSize: 10,
  transactionType: "semua",
  sortingField: "",
  sortingOrder: "",
};

export const initCashFilterInput = {
  outlets: [],
  transactionStartDate: null,
  transactionEndDate: null,
  page: 1,
  pageSize: 10,
  transactionType: "semua",
  sortingField: "",
  sortingOrder: "",
};

export const renderCapitalColumns = (handleDetailButtonClick = null) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "10%",
    },
    {
      dataIndex: "outletName",
      key: "outletName",
      backend_key: "outlet_name",
      title: "Nama Cabang",
      sorter: true,
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      backend_key: "customer_name",
      title: "Nama Nasabah",
      sorter: true,
    },
    {
      dataIndex: "officerName",
      key: "officerName",
      backend_key: "officer_name",
      title: "Nama PoD/Officer",
      sorter: true,
    },
    {
      dataIndex: "transactionType",
      key: "transactionType",
      title: "Jenis Transaksi",
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: "Jumlah",
      width: "11%",
    },
    {
      dataIndex: "transactionMethod",
      key: "transactionMethod",
      title: "Metode Transaksi",
    },
    ...(handleDetailButtonClick
      ? [
          {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "7%",
            render: (_, record) => (
              <div style={{ textAlign: "center", display: "grid" }}>
                <Button
                  variant="primary"
                  className="btn-action btn-detail"
                  onClick={() => handleDetailButtonClick(record.transactionID)}
                >
                  Detail
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
};

export const cashColumns = (renderedImgColumn = true) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "7%",
    },
    {
      dataIndex: "outletName",
      key: "outletName",
      backend_key: "outlet_name",
      title: "Nama Cabang",
      sorter: true,
    },
    {
      dataIndex: "officerName",
      key: "officerName",
      backend_key: "officer_name",
      title: "Nama PoD/Officer",
      sorter: true,
      width: "20%",
    },
    {
      dataIndex: "transactionType",
      key: "transactionType",
      title: "Jenis Transaksi",
    },
    {
      dataIndex: "amount",
      key: "amount",
      title: "Jumlah",
    },
    {
      dataIndex: "description",
      key: "description",
      title: "Keterangan",
      width: "25%",
    },
    ...(renderedImgColumn
      ? [
          {
            dataIndex: "transactionProof",
            key: "transactionProof",
            title: "Bukti Transaksi",
          },
        ]
      : []),
  ];
};

export const capitalTransactionTypeList = [
  {
    text: "Semua",
    count: 0,
    value: "semua",
    active: true,
  },
  {
    text: "Pinjaman",
    count: 0,
    value: "disburse-loan",
    active: false,
  },
  {
    text: "Pembayaran",
    count: 0,
    value: "payment-loan",
    active: false,
  },
  {
    text: "Perpanjangan",
    count: 0,
    value: "extension",
    active: false,
  },
  {
    text: "Top Up",
    count: 0,
    value: "top up",
    active: false,
  },
  {
    text: "Setor",
    count: 0,
    value: "setor",
    active: false,
  },
];

export const cashTransactionTypeList = [
  {
    text: "Semua",
    count: 0,
    value: "semua",
    active: true,
  },
  {
    text: "Pengeluaran",
    count: 0,
    value: "pengeluaran",
    active: false,
  },
  {
    text: "Top Up",
    count: 0,
    value: "top up",
    active: false,
  },
  {
    text: "Setor",
    count: 0,
    value: "setor",
    active: false,
  },
];

export const CAPITAL_TYPE = "capital";
export const CASH_TYPE = "cash";
